import { Button, Grid, IconButton } from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import TimePicker from "../../../utils/FormFields/TimePicker";
import { FormikProps, FormikValues } from "formik";
import { IconCalendarTime, IconTrash } from "@tabler/icons";
import { EmployeeSignUpEmployeeAvailabilityDaysinfoMonday } from "../../../api/clinic-management";

type Props = {
  day: string;
};
const CalendarFields = ({ day }: Props) => {
  const formik: FormikProps<FormikValues> = useFormikContext();

  return (
    <>
      <FieldArray
        name={`Calendar.Daysinfo.${day}`}
        render={(arrayHelpers) => (
          <>
            {formik?.values?.Calendar?.Daysinfo[day]?.map(
              (jump: EmployeeSignUpEmployeeAvailabilityDaysinfoMonday, index: number) => (
                <>
                  <Grid container spacing={2} sx={{ p: 2 }} justifyContent="space-between" key={index}>
                    <Grid item xs={12} sm={5}>
                      <TimePicker label="Time From" name={`Calendar.Daysinfo.${day}[${index}].TimeFrom`} value={jump} />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TimePicker label="Time To" name={`Calendar.Daysinfo.${day}[${index}].TimeTo`} value={jump} />
                    </Grid>
                    <Grid item xs={4} sm={1}>
                      <IconButton onClick={() => arrayHelpers.remove(index)}>
                        <IconTrash color="red" />
                      </IconButton>
                    </Grid>
                  </Grid>
                </>
              )
            )}
            <Grid container sx={{ mt: 2, justifyContent: "center", alignContent: "center" }}>
              <Grid item xs={12} sm={4}>
                <Button
                  onClick={() => {
                    arrayHelpers.push({ TimeFrom: "", TimeTo: "" });
                  }}
                  color="primary"
                  variant="outlined"
                  fullWidth
                  sx={{
                    ml: { xs: 1, sm: -6 },
                    minWidth: "8vw",
                  }}
                >
                  <IconCalendarTime />
                  Add Time Slot
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      />
    </>
  );
};

export default CalendarFields;
